import { REACT_APP_ARPS_BASE_URL } from "../utils/urls";

const updateARPPSCustomer = async (customer_id: any, data: any) => {
  const response = await fetch(`${REACT_APP_ARPS_BASE_URL}/customers/${customer_id}`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
  const result = await response.json();
  return result;
};

export default updateARPPSCustomer;
